import { render, staticRenderFns } from "./UserRightsTable.vue?vue&type=template&id=800fccda&scoped=true"
import script from "./UserRightsTable.vue?vue&type=script&lang=ts"
export * from "./UserRightsTable.vue?vue&type=script&lang=ts"
import style0 from "./UserRightsTable.vue?vue&type=style&index=0&id=800fccda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800fccda",
  null
  
)

export default component.exports